import { Get, Patch, Post, Delete } from "./apiHelper";
import {
  CreateEmergencyPayload,
  EmergencyAssessmentPostPayload,
  Emergency
} from "../interfaces/EmergencyInterface";
import { ApiResponse } from "../interfaces/Api";

const emergencyRoot = "/api/emergency";

// TODO: remove
export const getEmergencyList = async (): Promise<Array<Emergency>> => {
  const response = await Get(emergencyRoot, true);
  return response.data?.data as Array<Emergency>;
};

// export const patchEmergency = async (
//   emergencyId: number,
//   payload: PatchEmergencyPayload
// ): Promise<Emergency> => {
//   const response = await Patch(`${emergencyRoot}/${emergencyId}`, payload, true);
//   return response.data?.data as Emergency;
// };

export const createEmergency = async (payload: CreateEmergencyPayload): Promise<Emergency> => {
  const response = await Post(emergencyRoot, payload, true);
  return response.data?.data as Emergency;
};

export const saveEmergencyAssessment = async (
  emergencyId: number,
  payload: EmergencyAssessmentPostPayload
): Promise<unknown> => {
  const response = await Post(`${emergencyRoot}/${emergencyId}/assessment`, payload, true);

  return response.data?.data;
};

export async function getEmergencies({
  resourceCentreId,
  active
}: {
  resourceCentreId: number;
  active: boolean;
}): Promise<ApiResponse<Array<Emergency>>> {
  const searchParams = new URLSearchParams();
  searchParams.append("resourceCentreId", resourceCentreId.toString());
  if (active) searchParams.append("active", active.toString());

  const response = await Get(`${emergencyRoot}?${searchParams.toString()}`, true);
  return response.data as ApiResponse<Array<Emergency>>;
}

export const postEmergency = async (
  payload: Partial<Emergency>
): Promise<ApiResponse<Emergency>> => {
  const response = await Post(emergencyRoot, payload, true);
  return response.data as ApiResponse<Emergency>;
};

export const patchEmergency = async (
  payload: Partial<Emergency>
): Promise<ApiResponse<Emergency>> => {
  const response = await Patch(`${emergencyRoot}/${payload.id}`, payload, true);
  return response.data as ApiResponse<Emergency>;
};

// delete emergency
export async function deleteEmergency(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${emergencyRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
